import React from 'react';
import { EmptySearchResult } from 'components';
import PropTypes from 'prop-types';

const ContentWrapp = ({ children, foundedItems, search, title }) => {
  if (!search && !foundedItems?.length) {
    return <EmptySearchResult title={title} />;
  }

  if ((search && !foundedItems?.length) || (search.length <= 3 && search.length > 0)) {
    return <EmptySearchResult title='No result.' />;
  }
  if (foundedItems.length) {
    return <div style={{ overflow: 'hidden' }}>{children}</div>;
  }
};

ContentWrapp.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  foundedItems: PropTypes.array,
  search: PropTypes.string,
};

export default ContentWrapp;
